import "../App.css";
import "./styles/inProgress.css";

function inProgress() {
  return <div className="soon"></div>;
}

export default inProgress;
